let Api = {
  PRO_LIST: "/finance-api/w/financeProduct/findPageList", //产品列表
  JG_LIST: "/finance-api/w/financeOrg/findAllList", //下拉 机构列表
  ADD_LIST: "/finance-api/w/financeProduct/saveOrUpdate", //新增 产品
  DEL_LIST: "/finance-api/w/financeProduct/del", //删除 产品
  SX_LIST: "/finance-api/w/financeProduct/onAndOffShel", //上下架 产品
  DL_LIST: "/finance-api/w/financeProduct/findInfo", //产品 详情
  CP_LIST: "/finance-api/w/financeProduct/findAllList", //产品 详情
  FIND_LIST: "/finance-api/w/applyRecords/findPageList", //申请记录 列表 数据
  JGFY_LIST: "/finance-api/w/financeOrg/findPageList", //机构 列表  数据
  JG_ADD: "/finance-api/w/financeOrg/saveOrUpdate", //机构 列表  数据
  JGDEL_LIST: "/finance-api/w/financeOrg/findInfo", //机构 详细数据
};
module.exports = Api;
